import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

/**
 * 活动配置时间 → 毫秒时间戳。
 * 服务端为 RFC3339（含时区偏移，如 +07:00），Date.parse 会转为 UTC 毫秒，与本地时区无关。
 */
export const parseActTimeToMs = (value) => {
  if (value == null || value === '') return NaN
  if (typeof value === 'number') {
    return value > 1e12 ? value : value * 1000
  }
  const text = String(value).trim()
  if (/^\d+$/.test(text)) {
    const num = Number(text)
    return num > 1e12 ? num : num * 1000
  }
  const parsed = Date.parse(text)
  return Number.isNaN(parsed) ? NaN : parsed
}

export const formatCountdownParts = (diffMs) => {
  const diff = Math.max(0, Math.floor(diffMs / 1000))
  const day = Math.floor(diff / 86400)
  const hour = Math.floor((diff % 86400) / 3600)
  const minute = Math.floor((diff % 3600) / 60)
  const second = diff % 60
  const pad2 = (n) => (n >= 10 ? String(n) : `0${n}`)
  return {
    day: pad2(day),
    hour: pad2(hour),
    minute: pad2(minute),
    second: pad2(second),
    hasDay: day > 0,
  }
}

/**
 * 活动日切（GMT+7）日期键 yyyyMMdd，用于匹配每日商品的 activeDate。
 * epoch + 7h 后用 UTC 取值即为 GMT+7 墙钟，避免受本地时区二次偏移影响。
 */
export const gmt7DateKey = (ms = Date.now()) => {
  const d = new Date(Number(ms) + 7 * 3600000)
  const pad = (n) => String(n).padStart(2, '0')
  return `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}`
}

export const formatRecordTime = (ms) => {
  const value = Number(ms || 0)
  if (!value) return '—'
  return dayjs(value).utcOffset(7).format('YYYY/M/D HH:mm')
}

// activeDate 是服务端日历日期键，不转换为用户本地时区。
export const formatDailyDate = (activeDate, locale) => {
  const text = String(activeDate || '')
  if (!/^\d{8}$/.test(text)) return text
  const year = Number(text.slice(0, 4))
  const month = Number(text.slice(4, 6))
  const day = Number(text.slice(6, 8))
  const date = new Date(Date.UTC(year, month - 1, day))
  if (date.getUTCFullYear() !== year || date.getUTCMonth() + 1 !== month || date.getUTCDate() !== day) return text
  if (locale === 'hk' || locale === 'tw') return `${month}月${day}日`
  if (locale === 'vi') return `Ngày ${day}/${month}`
  if (locale === 'id' || locale === 'th') {
    const monthName = new Intl.DateTimeFormat(locale, {
      month: locale === 'id' ? 'long' : 'short', timeZone: 'UTC',
    }).format(date)
    return `${day} ${monthName}`
  }
  const monthName = new Intl.DateTimeFormat('en', { month: 'short', timeZone: 'UTC' }).format(date)
  return `${monthName}. ${day}`
}
